<template></template>

<script lang="ts">
export default {
  name: "LinkIcon",
};
</script>

<style scoped></style>
